import moment from "moment";
import React, { useMemo } from "react";
import styles from "./style.module.css";
import DatePicker from "react-datepicker";
import { ko } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";
import { IClosedDate } from "data/company";

interface Props {
  style?: React.CSSProperties;
  onChange: (date: string, index: number) => void;
  index: number;
  value?: string;
  min?: string;
  closedDate?: IClosedDate[];
  closedWeekday?: string;
}
const beforeToday = moment().subtract(360, "days").format("YYYY-MM-DD");

export default function DateField({
  style,
  index,
  onChange,
  value,
  min,
  closedDate = [],
  closedWeekday = "",
  ...res
}: Props) {
  const filterDate = useMemo(() => {
    return closedDate.map((item) =>
      moment(item.closed_date).format("YYYY-MM-DD"),
    );
  }, [closedDate]);
  const filterWeekday = useMemo(() => {
    const defaultWeekday = ["일", "월", "화", "수", "목", "금", "토"];
    const closedWeekdayArr = (closedWeekday || "")
      .split(",")
      .filter((item) => !!item);
    const closedWeekDayNumArr = closedWeekdayArr.map((item) =>
      defaultWeekday.indexOf(item),
    );
    return closedWeekDayNumArr;
  }, [closedWeekday]);

  const isDatePicker = filterDate.length > 0 || filterWeekday.length > 0;

  return (
    <div className={styles.wrapper}>
      {!isDatePicker ? (
        <input
          type="date"
          style={{ ...style }}
          className={styles.dateField}
          onChange={(e) => onChange(e.target.value, index)}
          value={value}
          min={min || beforeToday}
          {...res}
        />
      ) : (
        <div className={styles.inputWrapper}>
          <DatePicker
            selected={moment(value).isValid() ? moment(value).toDate() : null}
            className={styles.dateField}
            onChange={(date) =>
              onChange(moment(date).format("YYYY-MM-DD"), index)
            }
            placeholderText="연도. 월. 일"
            dateFormat={"yyyy-MM-dd"}
            locale={ko}
            minDate={moment(min || beforeToday).toDate()}
            filterDate={(date) => {
              const filteredDate = !filterDate.includes(
                moment(date).format("YYYY-MM-DD"),
              );
              const filteredWeekday = !filterWeekday.includes(date.getDay());

              const filter = filteredDate && filteredWeekday;
              return filter;
            }}
          />
        </div>
      )}
    </div>
  );
}
